import React, { ReactNode } from "react";
import { useSchoolBasedTranslation } from "hooks/useSchoolBasedTranslation";

interface TranslationProviderProps {
  children: ReactNode;
}

/**
 * Component that automatically manages translation language switching based on school's isOrganization flag
 * This component should be placed high in the component tree to ensure translations are switched globally
 */
export const TranslationProvider: React.FC<TranslationProviderProps> = ({
  children,
}) => {
  // This hook automatically switches the language based on the current school's isOrganization flag
  useSchoolBasedTranslation();

  return <>{children}</>;
};
